<template>
  <div class="form form-invoice">
    <h5>{{ $t("message.contracts.document_liability_insurance") }}</h5>
    <br />
    <div
      class="alert mt-2 alert-success rounded d-flex"
      v-if="LiabilityInsurance.IsSigned"
    >
      <span style="flex-basis: 50%">
        {{
          $t(
            "message.contracts.signed_message_" +
              LiabilityInsurance.SignatureType,
          )
        }}
        {{ LiabilityInsurance.SignDate }}<br />
        {{ LiabilityInsurance.SignatureName }}
      </span>
    </div>
    <div class="row">
      <div class="col-md-12">
        <h5>{{ $t("message.contracts.liability_insurance_policy_holder") }}</h5>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.policy_holder_name"
            :placeholder="
              $t('message.contracts.liability_insurance_policy_holder_name')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_policy_holder_name"
          />
          <label
            for="liability_insurance_policy_holder_name"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_policy_holder_name")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.policy_holder_address"
            :placeholder="
              $t('message.contracts.liability_insurance_policy_holder_address')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_policy_holder_address"
          />
          <label
            for="liability_insurance_policy_holder_address"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_policy_holder_address")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.policy_holder_phone"
            :placeholder="
              $t('message.contracts.liability_insurance_policy_holder_phone')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_policy_holder_phone"
          />
          <label
            for="liability_insurance_policy_holder_phone"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_policy_holder_phone")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.policy_holder_email"
            :placeholder="
              $t('message.contracts.liability_insurance_policy_holder_email')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_policy_holder_email"
          />
          <label
            for="liability_insurance_policy_holder_email"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_policy_holder_email")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.policy_holder_bank"
            :placeholder="
              $t('message.contracts.liability_insurance_policy_holder_bank')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_policy_holder_bank"
          />
          <label
            for="liability_insurance_policy_holder_bank"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_policy_holder_bank")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.policy_holder_bin"
            :placeholder="
              $t('message.contracts.liability_insurance_policy_holder_bin')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_policy_holder_bin"
          />
          <label
            for="liability_insurance_policy_holder_bin"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_policy_holder_bin")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.policy_holder_bik"
            :placeholder="
              $t('message.contracts.liability_insurance_policy_holder_bik')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_policy_holder_bik"
          />
          <label
            for="liability_insurance_policy_holder_bik"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_policy_holder_bik")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <div class="togglebutton mb-0 form-label-group required">
          <label class="control-label-sm">
            <span>{{
              $t("message.contracts.liability_insurance_is_resident")
            }}</span
            ><br /><br />
            <input
              type="checkbox"
              :disabled="is_field_readonly"
              v-model="LiabilityInsurance.is_resident"
            />
            <span class="toggle"></span>
            <span class="female">{{ $t("message.yes") }}</span>
            <span class="male">{{ $t("message.no") }}</span>
          </label>
        </div>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.license_no"
            :placeholder="
              $t('message.contracts.liability_insurance_license_no')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_license_no"
          />
          <label
            for="liability_insurance_license_no"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.liability_insurance_license_no") }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.economy_sector"
            :placeholder="
              $t('message.contracts.liability_insurance_economy_sector')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_economy_sector"
          />
          <label
            for="liability_insurance_economy_sector"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_economy_sector")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.activity_type"
            :placeholder="
              $t('message.contracts.liability_insurance_activity_type')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_activity_type"
          />
          <label
            for="liability_insurance_activity_type"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_activity_type")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.object_teritory"
            :placeholder="
              $t('message.contracts.liability_insurance_object_teritory')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_object_teritory"
          />
          <label
            for="liability_insurance_object_teritory"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_object_teritory")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <textarea
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.insured_details"
            :placeholder="
              $t('message.contracts.liability_insurance_insured_details')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_insured_details"
          ></textarea>
          <label
            for="liability_insurance_insured_details"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_insured_details")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-12">
        <h5>{{ $t("message.contracts.liability_insurance_insured_sum") }}</h5>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="liability_insurance_life_insured_sum"
            :class="[
              'form-label-group-label shorter',
              LiabilityInsurance.life_insured_sum != '' ? 'high' : '',
            ]"
            >{{
              $t("message.contracts.liability_insurance_life_insured_sum")
            }}</label
          >
          <cleave
            :disabled="is_field_readonly"
            id="liability_insurance_life_insured_sum"
            v-model="LiabilityInsurance.life_insured_sum"
            :options="cleaveWeight"
            class="form-control"
            :placeholder="
              $t('message.contracts.liability_insurance_life_insured_sum')
            "
            autocomplete="off"
            style="cursor: auto"
          ></cleave>
        </span>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="liability_insurance_property_insured_sum"
            :class="[
              'form-label-group-label shorter',
              LiabilityInsurance.property_insured_sum != '' ? 'high' : '',
            ]"
            >{{
              $t("message.contracts.liability_insurance_property_insured_sum")
            }}</label
          >
          <cleave
            :disabled="is_field_readonly"
            id="liability_insurance_property_insured_sum"
            v-model="LiabilityInsurance.property_insured_sum"
            :options="cleaveWeight"
            class="form-control"
            :placeholder="
              $t('message.contracts.liability_insurance_property_insured_sum')
            "
            autocomplete="off"
            style="cursor: auto"
          ></cleave>
        </span>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="liability_insurance_cargo_insured_sum"
            :class="[
              'form-label-group-label shorter',
              LiabilityInsurance.cargo_insured_sum != '' ? 'high' : '',
            ]"
            >{{
              $t("message.contracts.liability_insurance_cargo_insured_sum")
            }}</label
          >
          <cleave
            :disabled="is_field_readonly"
            id="liability_insurance_cargo_insured_sum"
            v-model="LiabilityInsurance.cargo_insured_sum"
            :options="cleaveWeight"
            class="form-control"
            :placeholder="
              $t('message.contracts.liability_insurance_cargo_insured_sum')
            "
            autocomplete="off"
            style="cursor: auto"
          ></cleave>
        </span>
      </div>

      <div class="col-md-12">
        <h5>{{ $t("message.contracts.liability_insurance_insured_limit") }}</h5>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="liability_insurance_property_total_insured_sum"
            :class="[
              'form-label-group-label shorter',
              LiabilityInsurance.total_insured_sum != '' ? 'high' : '',
            ]"
            >{{
              $t("message.contracts.liability_insurance_total_insured_sum")
            }}</label
          >
          <cleave
            :disabled="is_field_readonly"
            id="liability_insurance_property_total_insured_sum"
            v-model="LiabilityInsurance.total_insured_sum"
            :options="cleaveWeight"
            class="form-control"
            :placeholder="
              $t('message.contracts.liability_insurance_total_insured_sum')
            "
            autocomplete="off"
            style="cursor: auto"
          ></cleave>
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.payout_term"
            :placeholder="
              $t('message.contracts.liability_insurance_payout_term')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_payout_term"
          />
          <label
            for="liability_insurance_payout_term"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_payout_term")
            }}</label
          >
        </span>
      </div>
      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.franchise"
            :placeholder="$t('message.contracts.liability_insurance_franchise')"
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_franchise"
          />
          <label
            for="liability_insurance_franchise"
            class="form-label-group-label shorter"
            >{{ $t("message.contracts.liability_insurance_franchise") }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.insurance_term"
            :placeholder="
              $t('message.contracts.liability_insurance_insurance_term')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_insurance_term"
          />
          <label
            for="liability_insurance_insurance_term"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_insurance_term")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.insurance_teritory"
            :placeholder="
              $t('message.contracts.liability_insurance_insurance_teritory')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_insurance_teritory"
          />
          <label
            for="liability_insurance_insurance_teritory"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_insurance_teritory")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.transport_type"
            :placeholder="
              $t('message.contracts.liability_insurance_transport_type')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_transport_type"
          />
          <label
            for="liability_insurance_transport_type"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_transport_type")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-12">
        <h5>{{ $t("message.contracts.liability_insurance_transport_h") }}</h5>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.transport_model"
            :placeholder="
              $t('message.contracts.liability_insurance_transport_model')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_transport_model"
          />
          <label
            for="liability_insurance_transport_model"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_transport_model")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.transport_name"
            :placeholder="
              $t('message.contracts.liability_insurance_transport_name')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_transport_name"
          />
          <label
            for="liability_insurance_transport_name"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_transport_name")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.transport_reg_number"
            :placeholder="
              $t('message.contracts.liability_insurance_transport_reg_number')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_transport_reg_number"
          />
          <label
            for="liability_insurance_transport_reg_number"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_transport_reg_number")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.transport_body_number"
            :placeholder="
              $t('message.contracts.liability_insurance_transport_body_number')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_transport_body_number"
          />
          <label
            for="liability_insurance_transport_body_number"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_transport_body_number")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-6">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.transport_release_date"
            :placeholder="
              $t('message.contracts.liability_insurance_transport_release_date')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_transport_release_date"
          />
          <label
            for="liability_insurance_transport_release_date"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_transport_release_date")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-1 d-block form-label-group']">
          <label
            for="liability_insurance_property_vehicles_number"
            :class="[
              'form-label-group-label shorter',
              LiabilityInsurance.vehicles_number != '' ? 'high' : '',
            ]"
            >{{
              $t("message.contracts.liability_insurance_vehicles_number")
            }}</label
          >
          <cleave
            :disabled="is_field_readonly"
            id="liability_insurance_property_vehicles_number"
            v-model="LiabilityInsurance.vehicles_number"
            :options="cleaveInt"
            class="form-control"
            :placeholder="
              $t('message.contracts.liability_insurance_vehicles_number')
            "
            autocomplete="off"
            style="cursor: auto"
          ></cleave>
        </span>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.previous_insurance_info"
            :placeholder="
              $t(
                'message.contracts.liability_insurance_previous_insurance_info',
              )
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_previous_insurance_info"
          />
          <label
            for="liability_insurance_previous_insurance_info"
            class="form-label-group-label shorter"
            >{{
              $t(
                "message.contracts.liability_insurance_previous_insurance_info",
              )
            }}</label
          >
        </span>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <textarea
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.valid_contracts_info"
            :placeholder="
              $t('message.contracts.liability_insurance_valid_contracts_info')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_valid_contracts_info"
          ></textarea>
          <label
            for="liability_insurance_valid_contracts_info"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_valid_contracts_info")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.insurer_name"
            :placeholder="
              $t('message.contracts.liability_insurance_insurer_name')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_insurer_name"
          />
          <label
            for="liability_insurance_insurer_name"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_insurer_name")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.insurer_address"
            :placeholder="
              $t('message.contracts.liability_insurance_insurer_address')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_insurer_address"
          />
          <label
            for="liability_insurance_insurer_address"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_insurer_address")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.insurer_phone"
            :placeholder="
              $t('message.contracts.liability_insurance_insurer_phone')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_insurer_phone"
          />
          <label
            for="liability_insurance_insurer_phone"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_insurer_phone")
            }}</label
          >
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.insurer_commission"
            :placeholder="
              $t('message.contracts.liability_insurance_insurer_commission')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_insurer_commission"
          />
          <label
            for="liability_insurance_insurer_commission"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_insurer_commission")
            }}</label
          >
        </span>
      </div>
      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.insurer_contact_name"
            :placeholder="
              $t('message.contracts.liability_insurer_contact_name')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_insurer_contact_name"
          />
          <label
            for="liability_insurance_insurer_contact_name"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_insurer_contact_name")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.insurer_contact_address"
            :placeholder="
              $t(
                'message.contracts.liability_insurance_insurer_contact_address',
              )
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_insurer_contact_address"
          />
          <label
            for="liability_insurance_insurer_contact_address"
            class="form-label-group-label shorter"
            >{{
              $t(
                "message.contracts.liability_insurance_insurer_contact_address",
              )
            }}</label
          >
        </span>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group']">
          <input
            :readonly="is_field_readonly"
            type="text"
            class="form-control"
            v-model="LiabilityInsurance.insurer_contact_phone"
            :placeholder="
              $t('message.contracts.liability_insurance_insurer_contact_phone')
            "
            autocomplete="off"
            style="cursor: auto"
            id="liability_insurance_insurer_contact_phone"
          />
          <label
            for="liability_insurance_insurer_contact_phone"
            class="form-label-group-label shorter"
            >{{
              $t("message.contracts.liability_insurance_insurer_contact_phone")
            }}</label
          >
        </span>
      </div>

      <div class="col-md-12">
        <span :class="['bmd-form-group mb-2 d-block form-label-group shorter']">
          <datepicker
            :disabled="is_field_readonly"
            value-type="YYYY-MM-DD"
            format="DD.MM.YYYY"
            @focus="LiabilityInsurance.insurance_date = ' '"
            @blur="
              LiabilityInsurance.insurance_date == ' '
                ? (LiabilityInsurance.insurance_date = '')
                : (LiabilityInsurance.insurance_date =
                    LiabilityInsurance.insurance_date)
            "
            inputClass="form-control"
            v-model="LiabilityInsurance.insurance_date"
            :placeholder="
              $t('message.contracts.liability_insurance_insurance_date')
            "
            :inputAttr="{ id: 'liability_insurance_insurance_date' }"
          />
          <label
            for="liability_insurance_insurance_date"
            class="form-label-group-label shorter"
            :class="
              LiabilityInsurance.insurance_date != '' &&
              LiabilityInsurance.insurance_date != null
                ? 'topped'
                : ''
            "
            >{{
              $t("message.contracts.liability_insurance_insurance_date")
            }}</label
          >
        </span>
      </div>

      <div class="buttons2 ml-3" v-if="is_edit">
        <button
          class="btn btn-success float-left"
          @click="saveDocument()"
          :disabled="buttons_loading"
        >
          {{
            $t(
              is_new
                ? "message.contracts.document_create"
                : "message.contracts.document_save",
            )
          }}
        </button>
      </div>
    </div>

    <div
      class="buttons"
      style="position: absolute; bottom: 16px; right: 20%; left: 20px"
      v-if="!is_field_readonly && !is_edit"
    >
      <button
        class="btn btn-outline-success btn-sm dropdown-toggle"
        type="button"
        id="dropdownMenuButton"
        data-toggle="dropdown"
        aria-haspopup="true"
        aria-expanded="false"
        :disabled="buttons_loading"
      >
        {{
          $t(
            is_new
              ? "message.contracts.document_create"
              : "message.contracts.document_save",
          )
        }}&nbsp;&nbsp;
        <div
          class="loading loading-button"
          v-if="loading"
          style="
            border-top-width: 2px;
            border-top-color: #4caf50;
            top: 30px;
            right: -93px;
          "
        ></div>
      </button>
      <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
        <a
          class="dropdown-item"
          style="color: #4caf50"
          v-if="!has_insurance_certificate"
          @click="saveDocument()"
          :disabled="buttons_loading"
          >{{
            $t(
              is_new
                ? "message.contracts.document_create"
                : "message.contracts.document_save",
            )
          }}</a
        >
        <a
          class="dropdown-item"
          style="color: #4caf50"
          v-if="!is_new"
          @click="submit_and_sign_dialog()"
          :disabled="buttons_loading"
          >{{ $t("message.contracts.submit_and_sign_button") }}</a
        >
      </div>
      <!--<button v-if="!has_insurance_certificate" class="btn btn-success float-left" @click="saveDocument()" :disabled=buttons_loading>{{$t(is_new?'message.contracts.document_create':'message.contracts.document_save')}}</button> -->
      <button
        v-if="!is_new && !has_insurance_certificate && !insurance_request_sent"
        class="btn btn-success btn-sm mr-2 float-left"
        v-b-modal.modal-send_request
        :disabled="buttons_loading"
      >
        {{ $t("message.contracts.send_insurance_request") }}
      </button>
      <a
        v-if="!is_new && has_insurance_certificate"
        rel="noopener noreferrer"
        :href="insurance_request.certificate"
        target="_blank"
        class="btn btn-success btn-sm mr-2 float-left"
        :disabled="buttons_loading"
        >{{ $t("message.contracts.download_insurance_certificate") }}</a
      >
      <!-- <button v-if="!is_new" class="btn btn-success float-left" @click="submit_and_sign_dialog()" :disabled=buttons_loading>{{$t('message.contracts.submit_and_sign_button')}}</button> -->
      <!-- <button class="btn btn-info float-right" @click="exportEfreight()">e-Freight</button> -->
    </div>

    <b-modal
      id="modal-select-ecp-type-liability-insurance"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.select_ecp_type')"
    >
      <div class="text-center" v-if="!show_code_sign_type">
        <button
          class="btn btn-outline-success btn-round"
          @click="signDocument()"
        >
          {{ $t("message.contracts.sign_with_ecp") }}
        </button>
        <div>
          <small>
            <i>
              {{ $t("message.contracts.only_for_kz") }}
            </i>
          </small>
        </div>
        <hr />
        <button
          class="btn btn-outline-success btn-round"
          @click="sign_with_code()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
      </div>
      <div class="text-center" v-if="show_code_sign_type">
        <div class="form-group">
          <label for="input-code">
            {{ $t("message.contracts.input_signature_code") }}
          </label>
          <input
            type="text"
            class="form-control"
            id="input-code"
            v-model="sign_with_code_code"
          />
        </div>
        <button
          class="btn btn-success btn-round"
          @click="sign_with_code_phase2()"
        >
          {{ $t("message.contracts.sign_with_code") }}
        </button>
        <hr />
        <button
          class="btn btn-default btn-round btn-sm"
          @click="show_code_sign_type = false"
        >
          {{ $t("message.cancel") }}
        </button>
      </div>
    </b-modal>

    <b-modal
      id="modal-send_request"
      :hide-footer="true"
      size="sm"
      :title="$t('message.contracts.send_insurance_request')"
    >
      <div class="col-md-12">
        <div class="form-group">
          <label for="insurance_statute">{{
            $t("message.account.statute")
          }}</label>
          <input
            type="file"
            id="insurance_statute"
            class="form-control1"
            @change="fileHandleInsurance($event, 'statute')"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label for="insurance_registration_certificate">{{
            $t("message.account.registration_certificate")
          }}</label>
          <input
            type="file"
            id="insurance_registration_certificate"
            class="form-control1"
            @change="fileHandleInsurance($event, 'registration_certificate')"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label for="insurance_signature_right_certificate">{{
            $t("message.account.signature_right_certificate")
          }}</label>
          <input
            type="file"
            id="insurance_signature_right_certificate"
            class="form-control1"
            @change="fileHandleInsurance($event, 'signature_right_certificate')"
          />
        </div>
      </div>
      <div class="col-md-12">
        <div class="form-group">
          <label for="insurance_ceo_passport">{{
            $t("message.account.ceo_passport")
          }}</label>
          <input
            type="file"
            id="insurance_ceo_passport"
            class="form-control1"
            @change="fileHandleInsurance($event, 'ceo_passport')"
          />
        </div>
      </div>
      <button class="btn btn-success" @click="saveInsuranceRequest">
        {{ $t("message.send") }}
      </button>
    </b-modal>
  </div>
</template>
<script>
var querystring = require("querystring");
import { required } from "vuelidate/lib/validators";
export default {
  props: [
    "goods",
    "contract_details",
    "document_id",
    "is_new",
    "document",
    "readonly",
    "is_edit",
    "files",
  ],
  name: "form-insurance",
  data() {
    return {
      buttons_loading: false,

      doc_id: "",
      show_code_sign_type: false,
      sign_with_code_code: "",

      LiabilityInsurance: {
        // doc_id:"1",
        policy_holder_name: "",
        policy_holder_address: "",
        policy_holder_phone: "",
        policy_holder_email: "",
        policy_holder_bank: "",
        policy_holder_bin: "",
        policy_holder_bik: "",
        is_resident: "",
        license_no: "",
        economy_sector: "",
        activity_type: "",
        object_teritory: "",
        insured_details: "",
        life_insured_sum: "",
        property_insured_sum: "",
        cargo_insured_sum: "",
        total_insured_sum: "",
        insurance_term: "",
        insurance_teritory: "",
        transport_type: "",
        transport_model: "",
        transport_name: "",
        transport_reg_number: "",
        transport_body_number: "",
        transport_release_date: "",
        vehicles_number: "",
        previous_insurance_info: "",
        valid_contracts_info: "",
        insurer_name: "",
        insurer_address: "",
        insurer_phone: "",
        insurance_date: "",
        insurer_commission: "",
        SignDate: "",
        SignatureType: "",
        SignatureName: "",
        franchise: "",
        payout_term: "",
        insurer_contact_name: "",
        insurer_contact_address: "",
        insurer_contact_phone: "",
        IsSigned: false,
      },

      cleaveWeight: {
        numeral: true,
        numeralPositiveOnly: true,
        blocks: [24],
        numeralDecimalScale: 6,
      },

      cleaveInt: {
        numeral: true,
        numeralDecimalMark: "",
        delimiter: "",
      },

      current_insurance_request: {
        statute: null,
        registration_certificate: null,
        signature_right_certificate: null,
        ceo_passport: null,
      },
      insurance_request: {},
      has_insurance_certificate: false,
      insurance_request_sent: false,
    };
  },
  methods: {
    /**
     * checks if current document has insurance request
     */
    load_insurance_requests() {
      axios
        .get(window.base + "/account/load_my_insurance_requests")
        .then((response) => {
          for (var i in response.data) {
            var request = response.data[i];
            if (request.document_id == this.doc_id) {
              this.insurance_request_sent = true;
              this.insurance_request = request;
              if (
                typeof request.certificate === "string" &&
                request.certificate != ""
              )
                this.has_insurance_certificate = true;
              break;
            }
          }
          // response.data.forEach(request => {
          // 	if(request.document_id == this.document_id){
          // 		this.insurance_request = request
          // 		if(typeof request.certificate === 'string' && request.certificate!='')
          // 			this.has_insurance_certificate = true
          // 	}
          // })
        });
    },
    /**
     * SAVES/updates insurance requests
     */
    saveInsuranceRequest() {
      let fd = new FormData();
      fd.append("contract_id", this.contract_details.attis_contract_id);
      fd.append("org_name", this.LiabilityInsurance.policy_holder_name);
      fd.append("ceo_name", this.LiabilityInsurance.insured_details);
      fd.append("document_id", this.document_id);
      fd.append("statute", this.current_insurance_request.statute);
      fd.append(
        "registration_certificate",
        this.current_insurance_request.registration_certificate,
      );
      fd.append(
        "signature_right_certificate",
        this.current_insurance_request.signature_right_certificate,
      );
      fd.append("ceo_passport", this.current_insurance_request.ceo_passport);
      fd.append("insurance_type", 7);
      fd.append("amount", this.LiabilityInsurance.total_insured_sum);
      // account/create_insurance_request
      axios
        .post(window.base + "/account/create_insurance_request", fd, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((response) => {
          if (response.data.status == "ok") {
            this.add_insurance_request = false;
            new Noty({
              theme: "light",
              type: "success",
              text: this.$t("message.message.success"),
              timeout: 5000,
            }).show();
            this.$bvModal.hide("modal-send_request");
            this.load_insurance_requests();
          } else {
            this.add_insurance_request = false;
            new Noty({
              theme: "light",
              type: "error",
              text: this.$t("message.message.no_success"),
              timeout: 5000,
            }).show();
            this.$bvModal.hide("modal-send_request");
            this.load_insurance_requests();
          }
        })
        .catch((e) => {
          this.add_insurance_request = false;
          new Noty({
            theme: "light",
            type: "error",
            text: this.$t("message.message.no_success"),
            timeout: 5000,
          }).show();
          this.$bvModal.hide("modal-send_request");
          this.load_insurance_requests();
        });
    },
    /**
     * handles file select event
     */
    fileHandleInsurance(event, type) {
      this.current_insurance_request[type] = event.target.files[0];
    },
    /**
     * Loads data from library using parameters type, query and qty,
     * sets results as an array to data-property with name of plural form of type
     */
    getLibrary(type, query, qty) {
      query = query.toLowerCase();
      axios
        .get(
          window.base +
            "/library?type=" +
            type +
            "&query=" +
            query +
            "&qty=" +
            qty +
            "&lang=" +
            this.$i18n.locale,
        )
        .then((response) => {
          var var_name = type;
          if (type[type.length - 1] == "s") {
            var_name = type + "es";
          } else if (type[type.length - 1] == "y") {
            var_name = type.substring(0, type.length - 1) + "ies";
          } else {
            var_name = type + "s";
          }
          this.$data[var_name] = [];
          response.data.forEach((item) => {
            if (item.value !== "··········") this.$data[var_name].push(item);
          });
        });
    },
    /**
     * Fetches list of measures from library
     */
    fetchMeasures(search, loading) {
      this.getLibrary("measure", search, 10000);
    },
    /**
     * Fetches list of currencies from library
     */
    fetchCurrencies(search, loading) {
      this.getLibrary("currency", search, 10000);
    },
    /**
     * Fetches list of companies from library
     */
    fetchCountries(search, loading) {
      this.getLibrary("country", search, 10000);
    },
    /**
     * Fetches list of companies from library
     */
    fetchContragents(search, loading) {
      this.getLibrary("company", search, 10000);
    },
    /**
     * get contract XML and sends it to backend along with token from e-mail to sign data
     * after signing it gets the signature code and sends it back to the backend
     * to store signature in document
     */
    sign_with_code_phase2() {
      if (this.sign_with_code_code != "") {
        axios
          .get(
            window.base +
              "/document/LoadLiabilityInsuranceXML?doc_id=" +
              this.document_id,
          )
          .then((response) => {
            var fd = new FormData();
            var xml = response.data.replace(
              '<?xml version="1.0" encoding="utf-16"?>',
              "",
            );
            fd.append("token", this.sign_with_code_code);
            fd.append("data", xml);
            axios
              .post(window.base + "/account/SignData", fd)
              .then((response) => {
                var fd = new FormData();
                fd.append("contract_id", this.document_id);
                fd.append("signature", response.data);
                axios
                  .post(window.base + "/document/AddDocumentSignature", fd)
                  .then(() => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "success",
                      text: this.$root.$t("message.message.contract_signed"),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide(
                      "modal-select-ecp-type-liability-insurance",
                    );
                  })
                  .catch((e) => {
                    this.loading = false;
                    new Noty({
                      theme: "light",
                      type: "error",
                      text: this.$root.$t(
                        "message.message.contract_not_signed",
                      ),
                      timeout: 5000,
                    }).show();
                    this.$bvModal.hide(
                      "modal-select-ecp-type-liability-insurance",
                    );
                  });
              });
          });
      }
    },
    /**
     * Sends request to backend to send a code to sign a document without ECP
     */
    sign_with_code() {
      axios
        .get(window.base + "/account/GenerateToken?doc_id=" + this.document_id)
        .then((response) => {
          console.log(response.data);
          this.show_code_sign_type = true;
        });
    },
    /**
     * Initializes electorinc signature for the document.
     * Gets XML from backend.
     * Signs with NCA Layer.
     * Sends signature back to backend to store for future comparison.
     */
    signDocument() {
      this.loading = true;
      axios
        .get(
          window.base +
            "/document/LoadLiabilityInsuranceXML?doc_id=" +
            this.document_id,
        )
        .then((response) => {
          this.xml = response.data.replace(
            '<?xml version="1.0" encoding="utf-16"?>',
            "",
          );
          window.webSocket = new WebSocket("wss://127.0.0.1:13579/");
          window.callback = null;

          window.webSocket.onopen = (event) => {
            window.signXml("PKCS12", "SIGNATURE", this.xml, () => {});
          };

          window.webSocket.onclose = function (event) {
            if (event.wasClean) {
            } else {
              openDialog();
            }
          };

          window.webSocket.onmessage = (event) => {
            var result = JSON.parse(event.data);
            if (result != null) {
              var rw = {
                code: result["code"],
                message: result["message"],
                responseObject: result["responseObject"],
                getResult: function () {
                  return this.result;
                },
                getMessage: function () {
                  return this.message;
                },
                getResponseObject: function () {
                  return this.responseObject;
                },
                getCode: function () {
                  return this.code;
                },
              };
              if (rw.code == "200") {
                var oParser = new DOMParser();
                var oDOM = oParser.parseFromString(
                  rw.getResponseObject(),
                  "application/xml",
                );
                var value =
                  oDOM.getElementsByTagName("ds:SignatureValue")[0].innerHTML;
                var certificate =
                  oDOM.getElementsByTagName("ds:X509Certificate")[0].innerHTML;

                axios
                  .get(window.base + "/account/loadSignatureDetails")
                  .then((response) => {
                    let cert = response.data.cert.replace(
                      /(?:\r\n|\r|\n)/g,
                      "",
                    );
                    if (cert == certificate.replace(/(?:\r\n|\r|\n)/g, "")) {
                      var fd = new FormData();
                      let name = response.data.cert_name;
                      fd.append("document_id", this.document_id);
                      fd.append("contract_id", this.document_id);
                      fd.append("signature_name", name);
                      fd.append("signature", value);
                      fd.append("type", "signature");
                      axios
                        .post(
                          window.base + "/document/AddDocumentSignature",
                          fd,
                        )
                        .then(() => {
                          this.loading = false;
                          this.load(); //refresh status of the contract
                          new Noty({
                            theme: "light",
                            type: "success",
                            text: this.$t("message.message.document_signed"),
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide(
                            "modal-select-ecp-type-liability-insurance",
                          );
                        })
                        .catch((e) => {
                          this.loading = false;
                          new Noty({
                            theme: "light",
                            type: "error",
                            text:
                              this.$t("message.message.document_not_signed") +
                              " (" +
                              e +
                              ")",
                            timeout: 5000,
                          }).show();
                          this.$bvModal.hide(
                            "modal-select-ecp-type-liability-insurance",
                          );
                        });
                    } else {
                      this.loading = false;
                      new Noty({
                        theme: "light",
                        type: "error",
                        text: this.$t(
                          "message.message.document_not_signed_cert_invalid",
                        ),
                        timeout: 5000,
                      }).show();
                    }
                  });

                // var fd = new FormData;
                // fd.append('contract_id', this.document_id)
                // fd.append('signature', value)
                // axios.post(window.base + '/document/AddDocumentSignature', fd).then(()=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'success',
                // 		text: this.$root.$t('message.message.document_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // }).catch(e=>{
                // 	this.loading = false
                // 	new Noty({
                // 		theme: 'light',
                // 		type: 'error',
                // 		text: this.$root.$t('message.message.document_not_signed'),
                // 		timeout: 5000,
                // 	}).show();
                // 	this.$bvModal.hide('modal-select-ecp-type-invoice')
                // })
                window.webSocket.close();
                // window.webSocket.removeEventListener('message', {})
              }
            }
          };
        });
    },
    load() {
      axios
        .get(
          window.base +
            "/Document/LoadLiabilityInsurance/?doc_id=" +
            this.document_id,
        )
        .then((response) => {
          this.$emit("file", response.data.files);
          this.LiabilityInsurance = response.data;
          this.doc_id = response.data.doc_id;
        });
    },
    /**
     * checks field value and if it should be int/decimal but is empty set's 0
     */
    check_field_value(field, value) {
      let list_of_decimal_fields = [
        "life_insured_sum",
        "property_insured_sum",
        "cargo_insured_sum",
        "total_insured_sum",
      ];
      let list_of_int_fields = ["ID", "vehicles_number"];

      let list_of_bool_fields = ["is_resident"];

      if (field == "ID") return value;

      if (_.includes(list_of_decimal_fields, field)) {
        if (_.isEmpty(value) || value == "0" || value == "0.0")
          return 0.0; //zero double
        else return parseFloat(value);
      } else if (_.includes(list_of_int_fields, field)) {
        if (_.isEmpty(value) || value == "0" || value == "0.0")
          return 0; //zero int
        else return parseInt(value);
      } else if (_.includes(list_of_bool_fields, field)) {
        if (value === true || value == 1) return 1;
        else return 0;
      } else {
        if (_.isEmpty(value)) return "";
        else return value;
      }
    },
    check_json_before_sending(json) {
      let tmp = {};
      for (let i in json) {
        if (_.isArray(json[i])) {
          if (json[i].length == 0) tmp[i] = [];
          json[i].forEach((array_item, j) => {
            tmp[i] = [];
            if (typeof array_item === "object") {
              tmp[i].push(this.check_json_before_sending(array_item));
            } else {
              tmp[i].push(this.check_field_value(j, array_item));
            }
          });
        } else if (typeof json[i] === "object") {
          tmp[i] = this.check_json_before_sending(json[i]);
        } else {
          tmp[i] = this.check_field_value(i, json[i]);
        }
      }
      return tmp;
    },
    submit_and_sign_dialog() {
      this.$bvModal.show("modal-select-ecp-type-liability-insurance");
    },
    saveDocument() {
      var data = {
        document: this.document,
      };
      this.$root.$emit("show-loading");
      this.buttons_loading = true;
      var tmp = this.LiabilityInsurance;
      tmp.files = this.files;
      var t1 = this.$t("message.error");
      axios
        .post(
          window.base +
            (this.is_new === true
              ? "/Document/createLiabilityInsurance" +
                "?attis_contract_id=" +
                this.$route.params.id +
                "&contract_id=" +
                this.$route.params.id
              : "/Document/updateLiabilityInsurance" +
                "?doc_id=" +
                this.document_id),
          this.check_json_before_sending(tmp),
        )
        .then((response) => {
          console.log(response.data);
          if (response.data == "ok") {
            new Noty({
              theme: "light",
              type: "success",
              text: this.$root.$t("message.message.insurance-created"),
              timeout: 5000,
            }).show();
            this.$root.$emit("loadDocuments", { category: "all" });
            this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
            this.$root.$emit(
              "bv::hide::modal",
              "modal-document-new",
              "#btnShow",
            );
            if (this.is_edit) {
              this.$root.$emit("insurance-saved");
            }
          } else {
            console.info("else case");
            new Noty({
              theme: "light",
              type: "error",
              text:
                this.$root.$t("message.message.insurance-not-created") +
                " (" +
                response.data +
                ")",
              timeout: 5000,
            }).show();
            if (window.dev_mode) {
              this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
              this.$root.$emit(
                "bv::hide::modal",
                "modal-document-new",
                "#btnShow",
              );
            }
          }
        })
        .catch((e) => {
          console.log(e);
          new Noty({
            theme: "light",
            type: "error",
            text: t1,
            timeout: 5000,
          }).show();
          this.$root.$emit("bv::hide::modal", "modal-document", "#btnShow");
          this.$root.$emit("bv::hide::modal", "modal-document-new", "#btnShow");
        });
    },
  },
  mounted() {
    // this.fetchContragents('')
    // this.fetchCountries('')
    // this.fetchCurrencies('')
    // this.fetchMeasures('')
    if (this.document_id != "new") {
      this.load();
      this.load_insurance_requests();
    } else {
      axios
        .get(
          window.base +
            "/document/InsuranceInitialData?attis_contract_id=" +
            this.$route.params.id,
        )
        .then((response) => {
          console.log("insurance initial");
          console.log(response.data);
          var owner = response.data.contract_owner.organizations;
          var person = response.data.contract_owner.persons;
          var address = response.data.contract_owner.addresses[0];
          var residency =
            response.data.contract_owner.org_residency.display_text;
          var bank = response.data.contract_owner.banks[0];
          this.LiabilityInsurance.policy_holder_name = owner.org_name;
          this.LiabilityInsurance.policy_holder_address =
            residency +
            ", " +
            address.post_addr_district +
            " " +
            address.post_addr_region +
            ", " +
            address.post_addr_streethouse +
            " " +
            address.post_addr_house +
            " " +
            address.post_addr_room;
          this.LiabilityInsurance.policy_holder_phone =
            person.person_phone_number;
          this.LiabilityInsurance.policy_holder_email = owner.company_email;
          this.LiabilityInsurance.policy_holder_bank =
            bank.subj_bank_name +
            " " +
            bank.subj_bank +
            " " +
            bank.subj_bank_acc_number;
          this.LiabilityInsurance.policy_holder_bin = bank.subj_bank_bin;
          this.LiabilityInsurance.policy_holder_bik = bank.subj_bank;
          if (owner.org_oked != null) {
            axios
              .get(
                window.base +
                  "/library/oked?code=" +
                  owner.org_oked +
                  "&lang=" +
                  this.$i18n.locale,
              )
              .then((response) => {
                this.LiabilityInsurance.activity_type =
                  response.data[0].display_text;
              });
          }
        });

      // console.log("RWB contract details")
      // console.log(this.contract_details);
      // var date = new Date()
      // this.RWB.refdocid = parseInt((date.getDate()<10?'0'+date.getDate():date.getDate())+((date.getMonth()+1)<10?'0'+(date.getMonth()+1):(date.getMonth()+1)))
    }
  },
  computed: {
    locale() {
      var locale = this.$i18n.locale;
      var _this = this;
      switch (locale) {
        case "cn":
          locale = "zh-CN";
          break;
        case "en":
          locale = "en-US";
          break;
      }
      return locale;
    },
    is_field_readonly() {
      if (this.LiabilityInsurance.IsSigned || this.readonly) return true;
      return false;
    },
  },
  watch: {},
  validations: {},
};
</script>
<style>
#rwb_contract_date__outer_ {
  padding: 0 !important;
  height: 36px !important;
}
.b-form-timepicker label {
  background-image: none !important;
  align-self: center;
  padding-top: 6px;
  border: 0 !important;
}
.b-form-timepicker .btn {
  background: #fff !important;
  color: #3c4858;
}
</style>
